import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    back: 'Назад',
    title: 'Предпросмотр урока',
    restart: 'Начать заново',
    close: 'Закрыть',
    finished: 'Урок пройден',
    rehearsal: 'Это репетиция: ответы никуда не сохранены.',
    again: 'Пройти заново',
    loading: 'Загружаем урок…',
    position: (n: number, total: number) => `Блок ${n} из ${total}`,
    description: 'Прохождение урока так, как его увидит ученик. Ответы никуда не сохраняются.',
    lesson: 'Урок',
    untitled: 'Без названия',
    next: 'Далее',
  },
  en: {
    back: 'Back',
    title: 'Lesson preview',
    restart: 'Start over',
    close: 'Close',
    finished: 'Lesson complete',
    rehearsal: 'This is just a preview — answers aren’t saved.',
    again: 'Replay lesson',
    loading: 'Loading lesson…',
    position: (n: number, total: number) => `Block ${n} of ${total}`,
    description: 'Try the lesson the way a learner will see it. Answers aren’t saved.',
    lesson: 'Lesson',
    untitled: 'Untitled',
    next: 'Next',
  },
})
